import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Check: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        d="M9.288 14.775L17.763 6.3C17.963 6.1 18.1963 6 18.463 6C18.7297 6 18.963 6.1 19.163 6.3C19.363 6.5 19.463 6.7375 19.463 7.0125C19.463 7.2875 19.363 7.525 19.163 7.725L9.988 16.925C9.788 17.125 9.55467 17.225 9.288 17.225C9.02133 17.225 8.788 17.125 8.588 16.925L4.288 12.625C4.088 12.425 3.99217 12.1875 4.0005 11.9125C4.00883 11.6375 4.113 11.4 4.313 11.2C4.513 11 4.7505 10.9 5.0255 10.9C5.3005 10.9 5.538 11 5.738 11.2L9.288 14.775Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  </IconWrapper>
);
